import { Result } from '@/main/models/common/resultResponse';
import { AxiosResponse } from 'axios';
import { api, IRegistrationPublicApi } from '../base';
import { SupplierRegisterPublicRequest } from '@/main/models/request';

const baseRoute: string = 'RegistrationPublic';

export class RegistrationPublicApi extends IRegistrationPublicApi {
  confirmationcode(userEmail: string): Promise<AxiosResponse<Result<string>>> {
    return api.get(`${baseRoute}/confirmationcode_public`, {
      params: { userEmail }
    });
  }
  registerSupplierPublic(
    request: SupplierRegisterPublicRequest
  ): Promise<AxiosResponse<Result<string>>> {
    return api.post(`${baseRoute}/registerSupplier_public`, request);
  }
  registerBodyshopPublic(
    request: SupplierRegisterPublicRequest
  ): Promise<AxiosResponse<Result<string>>> {
    return api.post(`${baseRoute}/registerBodyshop_public`, request);
  }
}

